import { Injectable } from "@angular/core";
import * as d3 from "d3";
import { Grid, AStarFinder } from "pathfinding";

// import { start } from 'repl';
// import { stat } from 'fs';

@Injectable({
  providedIn: "root",
})
export class DataBridgeService {
  singlePointSize: number;
  aspectRatio: any;
  clientToMapWidthRatio: any;
  clientToMapHeightRatio: any;
  seatList: any;
  assetsLocation: any;
  colorMapping: any;
  MAP_HEIGHT: any;
  MAP_WIDTH: any;
  HOST_HEIGHT: number;
  HOST_WIDTH: number;
  footPrintsCounter: number;
  footPrintSize = 6;
  pointerWidth  = 7;
  pointerHeight = 7;
  scaledfpW = 6;
  scaledfpH = 6;

  static animationOver : any = false;

  constructor() {}

  cloneObject(obj) {
    return JSON.parse(JSON.stringify(obj));
  }

  getColorMapping() {
    return this.colorMapping;
  }

  setColorMapping(colorMapping: any) {
    this.colorMapping = colorMapping;
  }

  getAssetsLocation(): any {
    return this.assetsLocation;
  }

  setAssetsLocation(assetsLocation: any) {
    this.assetsLocation = assetsLocation;
  }

  getSinglePointSize() {
    return this.singlePointSize;
  }

  setSinglePointSize(val) {
    this.singlePointSize = val;
  }

  getClientToMapHeightRatio() {
    return this.clientToMapHeightRatio;
  }

  getClientToMapWidthRatio() {
    return this.clientToMapWidthRatio;
  }

  calculateClientToMapRatio() {
    this.HOST_HEIGHT = document.getElementById("platform").clientHeight - 20;
    this.HOST_WIDTH = document.getElementById("platform").clientWidth - 20;
    this.clientToMapWidthRatio = this.HOST_WIDTH / this.MAP_WIDTH;
    this.clientToMapHeightRatio = this.HOST_HEIGHT / this.MAP_HEIGHT;
  }

  getAspectRatio() {
    return this.aspectRatio;
  }

  setAspectRatio(size: any) {
    if (size) {
      var HW = size;
      this.MAP_HEIGHT = HW[1];
      this.MAP_WIDTH = HW[0];
      this.aspectRatio = this.MAP_WIDTH / this.MAP_HEIGHT;
    }
  }

  getMAP_HEIGHT() {
    return this.MAP_HEIGHT;
  }

  getMAP_WIDTH() {
    return this.MAP_WIDTH;
  }

  getHOST_HEIGHT() {
    return this.HOST_HEIGHT;
  }

  getHOST_WIDTH() {
    return this.HOST_WIDTH;
  }

  getSeatsList() {
    return this.cloneObject(this.seatList);
  }

  setSeatList(seatList) {
    this.seatList = seatList;
  }
  setClientToMapHeightRatio(clientToMapHeightRatio: number) {
    this.clientToMapHeightRatio = clientToMapHeightRatio;
  }

  setClientToMapWidthRatio(clientToMapWidthRatio: number) {
    this.clientToMapWidthRatio = clientToMapWidthRatio;
  }

  convertDataToGeoJson(apiResponse, image?) {
    let floorData = apiResponse.floor;
    let floorSeatsDTOMap = apiResponse.floorSeatsDTOMap
    let respObj = {
      geoJson: {
        type: "FeatureCollection",
        features: [],
        image: image || null,
      },
      floorDetails: Object.assign({}, floorData),
    };
    let roomFeatures = [];
    let seatFeatures = [];
    let rooms = {};
    floorData["subPolygonList"].forEach((element) => {
      let feature = this.getFeatureFromPolygon(element);
      if (element.polygonType == "ROOM") {
        roomFeatures.push(feature);
        if (!!!rooms[feature.styling?.level]) {
          rooms[feature.styling?.level] = [];
        }
        rooms[feature.styling?.level].push(feature);
      } else if (element.polygonType == "SEAT") {
        if(this.getQueryStringValue('view') === 'parking-view'){
          if(floorSeatsDTOMap[feature.properties.ID]){
            seatFeatures.push(feature);
          }
          else return;
        }
        else seatFeatures.push(feature);
      } else seatFeatures.push(feature);
    });
    roomFeatures = this.arrangeRoomsByLevel(rooms);
    {
      let feature = {
        type: "Feature",
        geometry: { coordinates: [], type: "Polygon" },
        properties: {
          ID: floorData.floorId,
          name: floorData.floorName,
          type: floorData.polygonType,
        },
      };
      let coordinateList;
      try {
        coordinateList = floorData["wkt"]
          ?.replaceAll("(", "")
          .replaceAll(")", "")
          .split(",");
      } catch (Exception) {
        coordinateList = floorData["wkt"]?.replace(/\(|\)/g, "").split(",");
      }
      let geoJsonCoordinateList = [];
      if (coordinateList) {
        coordinateList.forEach((coordinate) => {
          let x = parseInt(coordinate.split(" ")[0]);
          let y = parseInt(coordinate.split(" ")[1]);
          geoJsonCoordinateList.push([x, y]);
        });
      }
      feature.geometry.coordinates.push(geoJsonCoordinateList);
      respObj["geoJson"]["features"].splice(0, 0, feature);
    }
    this.appendSeatBookingDetails(apiResponse.floorSeatsDTOMap, seatFeatures);
    respObj["geoJson"]["features"] = [
      ...respObj["geoJson"]["features"],
      ...roomFeatures,
      ...seatFeatures,
    ];
    this.setSeatList(seatFeatures);
    respObj = this.backwardCompatibilitySupport(respObj);
    return respObj;
  }
  getFeatureFromPolygon(element: any) {
    let feature = {
      type: "Feature",
      geometry: { coordinates: [], type: "" },
      properties: {
        ID: element.seatId || element.roomId,
        polygonId: element.polygonId,
        name: element.seatName || element.roomName,
        type: element.polygonType,
        amenities: element.polygonAmenities,
        extras: this.getJSONFromString(element.extras),
        isSanitized: element.isSanitized,
        groupType: element.status,
        tags: element.tags
      },
      // TODO : angle for seats are coming on root while for rooms, it is in style object. both should be generic.
      styling: {
        ...this.getJSONFromString(element.style || {}),
        angle:
          element.polygonType == "SEAT"
            ? element?.angle
            : this.getJSONFromString(element.style || {})?.angle,
      },
    };
    let coordinateList;
    try {
      coordinateList = element.wkt
        ?.replaceAll("(", "")
        .replaceAll(")", "")
        .split(",");
    } catch (Exception) {
      coordinateList = element.wkt?.replace(/\(|\)/g, "").split(",");
    }
    let geoJsonCoordinateList = [];
    coordinateList?.forEach((coordinate) => {
      let x = parseInt(coordinate.split(" ")[0]);
      let y = parseInt(coordinate.split(" ")[1]);
      geoJsonCoordinateList.push([x, y]);
    });
    feature["geometry"].type =
      geoJsonCoordinateList.length == 1 ? "Point" : "Polygon";
    feature.geometry.coordinates.push(geoJsonCoordinateList);
    return feature;
  }

  appendSeatBookingDetails(floorSeatsDTOMap: any, seatFeatures: any[]) {
    seatFeatures.forEach((seat) => {
      seat["properties"] = {
        ...seat["properties"],
        status: floorSeatsDTOMap[seat.properties.ID]?.seatStatus
          ? floorSeatsDTOMap[seat.properties.ID]?.seatStatus
          : "Not Available",
        bookedByDetails:
          floorSeatsDTOMap[seat.properties.ID]?.seatBookedBydetails,
        floorId: floorSeatsDTOMap[seat.properties.ID]?.floorId,
        teamId: floorSeatsDTOMap[seat.properties.ID]?.teamId,
        teamName: floorSeatsDTOMap[seat.properties.ID]?.teamName,
        groupType: floorSeatsDTOMap[seat.properties.ID]?.groupType
          ? floorSeatsDTOMap[seat.properties.ID]?.groupType
          : seat.properties.groupType,
        extras: {
          ...seat["properties"].extras,
          ...this.getJSONFromString(
            floorSeatsDTOMap[seat.properties.ID]?.polygonExtras
          ),
        },
      };
      if (floorSeatsDTOMap[seat.properties.ID]?.amenities.length > 0) {
        seat["properties"].amenities =
          floorSeatsDTOMap[seat.properties.ID]?.amenities;
      }
    });
  }

  arrangeRoomsByLevel(rooms: {}): any[] {
    let arrangedRooms = [];
    Object.keys(rooms).forEach((key) => {
      arrangedRooms.push(...rooms[key]);
    });
    return arrangedRooms;
  }

  getRandomArbitrary(min, max) {
    return Math.random() * (max - min) + min;
  }

  getJSONFromString(str) {
    try {
      return JSON.parse(str);
    } catch (Exception) {
      return str;
    }
  }

  backwardCompatibilitySupport(obj) {
    obj.geoJson.features.forEach((element) => {
      // TREAT CONFIRMED AS BOOKED
      if (element.properties.type == "SEAT") {
        if (element.properties.status.toLowerCase() == "confirmed")
          element.properties.status = "BOOKED";
        else if (element.properties.status.toLowerCase() == "active")
          element.properties.status = "AVAILABLE";
      }

      // CONSOLIDATE TEAM NAME
      if (!element.properties?.teamName && element.properties.bookedByDetails) {
        for (let i = 0; i < element.properties.bookedByDetails.length; i++) {
          if (element.properties.bookedByDetails[i].teamName) {
            element.properties.teamName =
              element.properties.bookedByDetails[i].teamName;
            break;
          }
        }
      }
    });
    return obj;
  }
  getSeatCoordinates(id) {
    var seatData = this.seatList;
    var coordinate = [];
    for (var i = 0; i < seatData.length; i++) {
      if (seatData[i].properties.name == id) {
        var idElement = document.getElementById(
          seatData[i].properties.ID
        ).children;
        coordinate = [
          {
            x: idElement[1].getAttribute("x"),
            y: idElement[1].getAttribute("y"),
            w: idElement[1].getAttribute("width"),
            h: idElement[1].getAttribute("height")
          },
        ];
      }
    }
    return coordinate;
  }

  adjustSize(){
    let seatIds = [];
    d3.selectAll("g").each((d: any, i) => {
      if (d['properties']?.type == "SEAT") {
        seatIds.push(d['properties'].ID);
      }
    });
    if(seatIds.length != 0 && document.getElementById(seatIds[0])){
      let NODE = document.getElementById(seatIds[0]);
      let width = NODE.getBoundingClientRect().width;
      let height = NODE.getBoundingClientRect().height;
      this.pointerHeight = this.pointerWidth = height > width ? height : width;  
    }
  }

  drawPath(coordinates, width, height ,fpSize) {
    this.adjustSize();
    let scaledWidth = (
      d3.select("#planContainer").node() as SVGSVGElement
    ).getBBox().width;
    let scaledHeight = (
      d3.select("#planContainer").node() as SVGSVGElement
    ).getBBox().height;
    let scalefactorX = scaledWidth / width;
    let scalefactorY = scaledHeight / height;
    this.scaledfpH = 45 * scalefactorY;
    this.scaledfpW = 45 * scalefactorX;
    this.footPrintSize = fpSize == null ?  this.scaledfpH : fpSize;
    DataBridgeService.animationOver = false;
    let path = this.generatePath(coordinates, width, height).toString();
    d3.select("#planContainer")
      .append("path")
      .attr("id", "directions")
      .style("stroke-dasharray", "3, 3")
      .style("fill", "none")
      .style("stroke-width", 1.5)
      .attr("d", path)
      .attr("stroke", "#000000")
      .style("visibility", "hidden");

    var arrowBox = d3
      .select("#planContainer")
      .append("text")
      .attr("id", "arrowDirections");
    var incrementValue = 100 / this.footPrintsCounter;
    for (var i = 0; i < 100; i += incrementValue) {
      d3.select("#planContainer")
        .append("text")
        .append("textPath")
        .attr("xlink:href", "#directions")
        .attr("startOffset", i + "%")
        .attr("id", "marker0")
        .text("⚫")
        .attr("font-size", "1px")
        .attr("transform", "rotate(90)")
        .attr("style", "visibility: hidden; dominant-baseline: central;");
    }
    var listOfPoints = [];
    d3.selectAll("textPath").each(function (d, i) {
      var eltv = d3.select(this);
      var x = (eltv.node() as SVGSVGElement).getBBox().x;
      var y = (eltv.node() as SVGSVGElement).getBBox().y;
      listOfPoints.push([x, y]);
    });
    var angleValues = [];
    for (var i = 0; i < listOfPoints.length; i++) {
      if (i + 1 < listOfPoints.length) {
        var angle = Math.atan2(
          listOfPoints[i + 1][1] - listOfPoints[i][1],
          listOfPoints[i + 1][0] - listOfPoints[i][0]
        );
        angleValues.push((angle * 180 * 7) / 22);
      }
    }
    const firstAngle = angleValues[0];
    angleValues = [firstAngle].concat(angleValues);
    // console.log(angleValues)
    var counter = -1;
    let footPrintWidth = this.footPrintSize;
    let footPrintHeight = this.footPrintSize;
    d3.selectAll("textPath").each(function (d, i) {
      counter += 1;
      var bBox = (d3.select(this).node() as SVGSVGElement).getBBox();
      var x = bBox.x;
      var y = bBox.y;
      let height = bBox.height/2;
      let width = bBox.width/2;
      let xScale = width - footPrintWidth/2;
      let yScale = height - footPrintHeight/2;
      let tpCenterX = x + width;  // image appended over textpath center ⚫
      let tpCenterY = y + height; 
      d3.select("#planContainer")
        .append("image")
        .attr("href",`assets/navigation/footPrints.svg`)
        .attr("id", "footPrintsMap" + counter)
        .attr("fpid" , counter)
        .attr("x", x + xScale)
        .attr("y", y + yScale)
        .attr("width", footPrintWidth)
        .attr("height", footPrintHeight)
        .attr("transform", "rotate( " + angleValues[counter] + "," + tpCenterX + "," + tpCenterY + ")")
        .style("dominant-baseline", "central")
        .style("visibility", "hidden")
        .transition()
        .duration(2000)
        .delay(counter * 400)
        .ease(d3.easeLinear)
        .attr("display", 1)
        .style("visibility", "visible");
    });
    setTimeout(() => {
      DataBridgeService.animationOver = true;
    } , 400*counter + 3000)
  }
  plotMarkers(data, coordinates, width, height, startLabelText, endLabelText) {
    var startId = this.getSeatCoordinates(startLabelText);
    var endId = this.getSeatCoordinates(endLabelText);
    let scaledWidth  = (d3.select("#planContainer").node() as SVGSVGElement).getBBox().width;
    let scaledHeight = (d3.select("#planContainer").node() as SVGSVGElement).getBBox().height;
    let scalefactorX = scaledWidth / width;
    let scalefactorY = scaledHeight / height;
    if (startId.length != 0) {
      let spWidth = startId[0].w ? startId[0].w : 7; 
      let spHeight = startId[0].h ? startId[0].h : 7;
      d3.select("#planContainer")
        .append("image")
        .attr("href", (d, i) => {
          return `assets/navigation/sp.svg`;
        })
        .attr("id", "startPoint")
        .attr("x", function () {
          return startId[0].x;
        })
        .attr("y", function () {
          return startId[0].y;
        })
        .attr("width", spWidth)
        .attr("height", spHeight);
    } else {
      let startPointx = (d3.select("#footPrintsMap0").node() as SVGSVGElement).getBBox().x;
      let startPointy = (d3.select("#footPrintsMap0").node() as SVGSVGElement).getBBox().y;
      d3.select("#planContainer")
        .append("image")
        .attr("href", (d, i) => {
          return `assets/navigation/sp.svg`;
        })
        .attr("id", "startPoint")
        .attr("x", function () {
          return startPointx;
        })
        .attr("y", function () {
          return startPointy;
        })
        .attr("width", this.pointerWidth)
        .attr("height", this.pointerHeight);
    }
    if (endId.length != 0) {
      let epWidth = endId[0].w ? endId[0].w : 8; 
      let epHeight = endId[0].h ? endId[0].h : 8;
      d3.select("#planContainer")
        .append("image")
        .attr("href", (d, i) => {
          return `assets/navigation/endPoint.svg`;
        })
        .attr("id", "endPoint")
        .attr("x", function () {
          return endId[0].x;
        })
        .attr("y", function () {
          return endId[0].y;
        })
        .attr("width", epWidth)
        .attr("height", epHeight);
    } else {
      var lastFootPrintId = Math.floor(this.footPrintsCounter);
      let endPointx = (d3.select("#footPrintsMap" +lastFootPrintId).node() as SVGSVGElement).getBBox().x > 0 ? (d3.select("#footPrintsMap" +lastFootPrintId).node() as SVGSVGElement).getBBox().x : coordinates[coordinates.length - 1].x * scalefactorX - 14;
      let endPointy = (d3.select("#footPrintsMap" + lastFootPrintId).node() as SVGSVGElement).getBBox().y > 0 ? (d3.select("#footPrintsMap" + lastFootPrintId).node() as SVGSVGElement).getBBox().y : coordinates[coordinates.length - 1].y * scalefactorY - 14;
      d3.select("#planContainer")
        .append("image")
        .attr("href", (d, i) => {
          return `assets/navigation/endPoint.svg`;
        })
        .attr("id", "endPoint")
        .attr("x", function () {
          return endPointx;
        })
        .attr("y", function () {
          return endPointy;
        })
        .attr("width", this.pointerWidth)
        .attr("height", this.pointerHeight);
    }

    d3.select("#planContainer")
      .append("image")
      .attr("href", (d, i) => {
        return `assets/navigation/you-tag.svg`;
      })
      .attr("id", "youPoint")
      .attr("x", function () {
        return coordinates[0].x * scalefactorX - 20;
      })
      .attr("y", function () {
        return coordinates[0].y * scalefactorY;
      })
      .attr("width", 15);
  }

  generatePath(coordinates, width, height) {
    var pathCoordinates = [];
    let scaledWidth = (
      d3.select("#planContainer").node() as SVGSVGElement
    ).getBBox().width;
    let scaledHeight = (
      d3.select("#planContainer").node() as SVGSVGElement
    ).getBBox().height;
    let scalefactorX = scaledWidth / width;
    let scalefactorY = scaledHeight / height;
    let path = d3.path();
    coordinates = coordinates.map((items) => {
      return { x: items.x * scalefactorX, y: items.y * scalefactorY };
    });
    path.moveTo(coordinates[0].x, coordinates[0].y);
    pathCoordinates.push([coordinates[0].x, coordinates[0].y]);
    coordinates.forEach((coord, i) => {
      if (i > 0) {
        pathCoordinates.push([coord.x, coord.y]);
        path.lineTo(coord.x, coord.y);
      }
    });
    // console.log(pathCoordinates);
    var length = 0;
    for (var i = 0; i < pathCoordinates.length; i++) {
      if (i + 1 < pathCoordinates.length) {
        length += Math.sqrt((pathCoordinates[i][0] - pathCoordinates[i + 1][0]) ** 2 + (pathCoordinates[i][1] - pathCoordinates[i+1][1]) ** 2);
      }
    }
    this.footPrintsCounter = length/ (this.footPrintSize * 2);
    return path;
  }
  findPath(startPoint, endPoint, matrix) {
    let grid = new Grid([1000, 1000]);
    let finder = new AStarFinder({
      allowDiagonal: false,
    });

    let tempGrid = grid.clone();
    let pathCalc = finder.findPath(
      startPoint[0],
      startPoint[1],
      endPoint[0],
      endPoint[1],
      tempGrid
    );
    return pathCalc;
  }
  getQueryStringValue(key) {
    let value = "";
    if (window.location.href) {
      const queryStringPairs = window.location.href.split('?')[1] && window.location.href.split('?')[1].split('&');
      if (queryStringPairs) {
        for (let i = 0; i < queryStringPairs.length; i++) {
          const pair = queryStringPairs[i].split('=');
          if (pair[0] === key) {
            value = pair[1];
            break;
          }
        }
      }
      return value;
    }
    return '';
  }

  static repeateAnimation() : any{
    // console.log(this.animationOver)
    if(this.animationOver){
      this.animationOver = false;
      let count = -1;
      d3.select("#planContainer").selectAll("image").each(function (d, i) {
        let element = d3.select(this); 
        if(element.attr("fpid")){
          count +=1;
          element.style("opacity", 0)
          .style("visibility", "hidden")
          .attr("display", 0)
          .transition()
          .duration(2000)
          .delay(count * 400)
          .ease(d3.easeLinear)
          .attr("display", 1)
          .style("visibility", "visible")
          .style("opacity", 1);
        }
      });
      // console.log(count);
      setTimeout(() => {
        this.animationOver = true;
      } , 400 * count + 3000)
      // console.log("Repeate Animation");
    }
  }
}
